
import { Component, OnInit, ViewChild, OnDestroy, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { first, shareReplay } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { crop_Datas } from '../../../../models/farmer-land.model';
import { FarmerLandDetailService } from 'src/app/services/farmer-land-detail.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import exifr from 'exifr';
import piexifjs from 'piexifjs';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';

@Component({
  selector: 'app-pre-estimate-survey-current',
  templateUrl: './pre-estimate-survey-current.component.html',
  styleUrls: ['./pre-estimate-survey-current.component.scss']
})
export class PreEstimateSurveyCurrentComponent implements OnInit {
  @ViewChild('farmerPreEstimateSurveyTable', { static: true })
  public farmerPreEstimateSurveyTable: Table;
  
  public farmerPreEstimateSurveyData: any = [];
  mobileFarmerPreEstimateSurveyData: any = [];
  displayPreEstDialog: boolean = false;
  isSubmitted: boolean = false;
  submitEstimateForm: FormGroup;
  latitude: any;
  longitude: any;
  geolocationsarray: any = [];
  overlays: any = [];
  mapEnable = false;
  public vendorRegId: any;
  selectedWatersourceType: string;
  componentList: any = [];
  public userId: any;
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  options = {
    center: { lat: 29.0588, lng: 76.0856 },
    zoom: 17,
    mapTypeId: google.maps.MapTypeId.SATELLITE,
    // draggable: false,
    // icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
  };

  programmeAppId: any;
  programmeFarmerName: any;
  programName: any;
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public webcamImage!: WebcamImage;
  public videoOptions: MediaTrackConstraints = {};
  public imageCaptured = false;
  public errors: WebcamInitError[] = [];
  private trigger: Subject<void> = new Subject<void>();
  @Output()
  public pictureTaken = new EventEmitter<WebcamImage>();
  displayBasic: boolean = false;
  displayCameraComponent: any = false;
  selctedFileType: any;
  documentList: any = [];
  insertPondAttachments: any = [];
  selectedCropType: any;
  selectedCorpModel: crop_Datas;
  selectedCorpModelList: any;
  selectedNodes1: any[] = [];
  cropTypeList: any[];
  allSchemeMaster: any[] = [];
  waterSourceList: any[];
  private nextWebcam: Subject<boolean | string> = new Subject<
    boolean | string
  >();
  waterSourceNames: any;
  ProgramID: any;
  cropBasedNames: any;
  error: string;
  vendorCode: any;
  allAttachementsList: any = [];
  attachementDisplayName: any = [];
  imageError: string;
  uploadOptions: any[];
  autoId: any;
  appId: any;
  editBilledData: boolean = false;
  coordinateError: any;
  public multiSortMeta: any;
  ipAddress: any = '000.000.000';
  landArea: number = 0;
  surveyArea: number = null;

  public refreshLocation: any;
  appVerificationItems:MenuItem[];
  appVerificationModel:any[]

  public isGPSError: boolean = false;
  public loading: boolean = false;
  public subscriptions: any = []
  public subjectSub:any;
  public selectedYear:any;

  public rowPlantSpacingData : any = [];

  public geoLocMulArray: any[] = [];
  locationError: string = '';
  capturedLocation: string = '';
  capturedDateTime: string = '';
  deviceName: string = navigator.userAgent;
  isLocationReady: boolean = false;
  locationCoords: { lat: number, lng: number } | null = null;
  // New properties for geofencing
  isInsideFencing: boolean = true;
  fencingError: string = '';

  constructor(
    private loader: AppLoaderService,
    private vendorService: VendorDashboardService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private flService: FarmerLandDetailService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private cryptoJsService: CryptoJsService,
    private farmerAppSer: FarmersApplicationService,
    private ipService: IpAddressService,
    public cd: ChangeDetectorRef,
    public router: Router,
    private service: BaseService,
    private cdr: ChangeDetectorRef,
    private confirmationService: ConfirmationService
  ) {
    (this.waterSourceList = [
      { id: 1, waterSource: 'Canal' },
      { id: 2, waterSource: 'Tubewell' },
      { id: 3, waterSource: 'STP' },
      { id: 4, waterSource: 'Over Flow Pond' },
    ]),
      (this.uploadOptions = [
        { name: 'Farmer Photo', code: 'farmer_photo' },
        { name: 'Water Source', code: 'water_source' },
        { name: 'Land Photo', code: 'land_photo' },
        { name: 'Others', code: 'others' },
      ]);
  }

  ngOnInit(): void {
    // this.onCapture();
    // this.getCurrentLocation();
    // this.addOverlay();

    // this.loadData();
    this.loadDataAndApplyFilter();

    this.getIP();
    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'Pre_estimate_survey_file');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.appVerificationModel,
            'Pre_estimate_survey_file'
          );
        },
      },
    ];
   
    
    this.submitEstimateForm = this.fb.group({
      soilType: ['', Validators.required],
      cropType: ['', Validators.required],
      cropId: ['', Validators.required],
      waterSource: ['', Validators.required],
      waterPressure: ['', Validators.required],
      waterQuality: ['', Validators.required],
      ph: ['', Validators.required],
      ec: ['', Validators.required],
      waterReq: ['', Validators.required],
      // plantSpacing: ['', Validators.required],
      // rowSpacing: ['', Validators.required],
      spacing: ['', Validators.required]
    });
    // this.farmerPreEstimateSurveyTable.filters['Status_Ar'] = [
    //   { value: 'P', matchMode: 'equals', operator: 'and' },
    // ];
    this.multiSortMeta = [];
    this.multiSortMeta.push({ field: 'AssignedDate', order: 1 });
    WebcamUtil.getAvailableVideoInputs().then(
      (mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      }
    );
  }

  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {

        
        this.selectedYear = res;
        this.loadData();
        this.farmerPreEstimateSurveyTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }

    if (this.refreshLocation) {
      clearTimeout(this.refreshLocation);
    }
  }

  onRefreshCurrentLocation(){
    this.overlays.forEach((val, index) => {
      if(val?.title == "Current Location"){
        this.overlays.splice(index, 1); 
      }
    })
    this.getCurrentLocation();
  }

  getCurrentLocation() {
    let overlay = this.overlays;
    let mapEnable = this.mapEnable;
    let instant = this;
    this.coordinateError = '';
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };

      function success(pos) {
        const crd = pos.coords;
        const obj = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        instant.options.center = obj;
        // const image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';
        
          const currentLocationMarker = new google.maps.Marker({
          position: { lat: obj?.lat, lng: obj?.lng },
          title: 'Current Location',
          icon: '../../../assets/map/location-icon-5.png',
        });

        overlay.push(currentLocationMarker)
        
        instant.mapEnable = true;
      }

      function error(err) {
        instant.isGPSError = true;
        let detailsMsg = '';
        if(err?.message== 'User denied Geolocation'){
          detailsMsg = 'Please enable Geolocation access.'
        } else{
          detailsMsg = 'Please Refresh the Current Location.'
        }
        instant.messageService.add({
          severity: 'error',
          summary: err.message,
          detail: detailsMsg,
        });
      }

      // this.mapEnable = true;
      navigator.geolocation.getCurrentPosition(success, error, options);
      // this.addOverlay();
    }
  }

  get f() {
    return this.submitEstimateForm.controls;
  }
  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }
  loadData() {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    // const token: any = this.tokenService.retrieve();
    this.vendorRegId = JSON.stringify(token?.officeCode);
    // let payload = atob(token?.value?.authToken?.split('.')[1]);
   // this.loader.start();
   this.loading = true;
    let sub = this.vendorService
      .GetPreEstimationSurvey(JSON.parse(payload)?.sub, "Current", this.selectedYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.getCorpType();
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(
          //   this.userId,
          //   'Pre-Estimation Survey',
          //   '',
          //   new Date(),
          //   'Success'
          // );
          data.forEach((e) => {
            if (e.AssignedDate) {
              e.AssignedDate = new Date(e.AssignedDate);
              e.registerationDate_filter = e.AssignedDate.toString().substring(
                4,
                24
              );
            }
            if (e.LastSubmittedDate) {
              e.LastSubmittedDate = new Date(e.LastSubmittedDate);
              e.registerationReassignDate_filter =
                e.LastSubmittedDate.toString().substring(4, 24);
            }
          });
          this.userId = JSON.parse(payload)?.sub;
          if (data.length > 0) {
            this.farmerPreEstimateSurveyData = data;
            this.appVerificationModel= this.farmerPreEstimateSurveyData 
            // this.mobileFarmerPreEstimateSurveyData = data;
            this.mobileFarmerPreEstimateSurveyData = this.farmerPreEstimateSurveyData.filter(val => val.FinYear==this.selectedYear);

          }
          else{
            this.farmerPreEstimateSurveyData = [];
            this.appVerificationModel= [] 
            this.mobileFarmerPreEstimateSurveyData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(
          //   this.userId,
          //   'Pre-Estimation Survey',
          //   '',
          //   new Date(),
          //   err
          // );
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
      
  }
  getCorpType() {
    this.flService
      .GetCorpType()
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.cropTypeList = files;
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Corp Type Details not loaded.',
          });
        },
      });
  }
  getCropTypeName(event) {
    const data = this.cropTypeList.find((element) => element.data == event);
    if (data) {
      this.cropBasedNames = data.children;
    } else {
      this.cropBasedNames = [];
    }
  }
  selectPreSurveyData(event) {}
  onCloseDialog() {
    this.isGPSError = false;
    clearInterval(this.refreshLocation);
    clearTimeout(this.refreshLocation);
    this.displayPreEstDialog = false;
    this.mapEnable = false;
    this.geolocationsarray = [];
    this.geoLocMulArray = [];
    this.overlays = this.overlays.filter(val => {
      return !val?.title?.includes('Coordinate')
    });
    this.documentList = [];
    this.isSubmitted = false;
    this.submitEstimateForm.reset();
    this.landArea = 0;
    this.surveyArea = null;
    this.addOverlay();
  }

  onDeleteCoordinate(i, tableNo) {
    this.geoLocMulArray[tableNo].splice(i, 1);
    for (let index = 0; index <  this.geoLocMulArray[tableNo].length; index++) {
      this.geoLocMulArray[tableNo][index].CornerID = `Polygon  ${tableNo+1} : Coordinate  ${index + 1}` ;
    }    

    if(this.geoLocMulArray[tableNo].length > 0){
      this.onSave(tableNo);
    }else{
      this.onSave(0);
    }
    // }
  }

  onDeleteNewPolygon(i){
    if (i >= 0 && i < this.geoLocMulArray.length) {
      this.geoLocMulArray.splice(i, 1);
      
      // Renaming the remaining polygon corner IDs
      for (let j = 0; j < this.geoLocMulArray.length; j++) {
        for (let k = 0; k < this.geoLocMulArray[j].length; k++) {
          this.geoLocMulArray[j][k].CornerID = `Polygon ${j + 1} : Coordinate ${k + 1}`;
        }
      }

      this.onSave(0);

    } else {
      console.error("Index out of bounds");
    }
  }
  
  onStartNewPolygon(index){
    this.geoLocMulArray.push([]);
    this.cdr.detectChanges();
  }

  onCapture(index) {
    if (this.documentList.length > 0) {
      // this.confirmationService.confirm({
      //     message: 'Are you sure you want to proceed?',
      //     header: 'Confirmation',
      //     icon: 'pi pi-info-circle',
      //     acceptIcon:"none",
      //     rejectIcon:"none",
      //     rejectButtonStyleClass:"p-button-text",
      //     accept: () => {
      //         true;
      //     },
      //     reject: () => {
      //         false;
      //         this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Process incomplete', life: 3000 });
      //     },
      //     key: 'positionDialog'
      // });

      if (!confirm('If you captured new coordinates, you have to re-capture all images within concerned farmer field. Do you want to proceed?')) {
        return;
      } else {
        this.documentList = [];
      }
    }

    this.cdr.detectChanges();
    let instant = this;
    this.coordinateError = '';
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      function success(pos) {
        let isInvalid = instant.geoLocMulArray[index].find((data) => {
          if (
            data.lat == pos.coords.latitude &&
            data.lng == pos.coords.longitude
          ) {
            return data;
          }
        });

        if (isInvalid) {
          instant.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:
              'Please move to a different location to get new coordinates.',
          });
          return;
        }

        const crd = pos.coords;
        const obj = {
          // CornerID: instant.geoLocMulArray[index].length + 1,
          CornerID: `Polygon  ${index+1} : Coordinate  ${instant.geoLocMulArray[index].length + 1}`,
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        instant.geoLocMulArray[index].push(obj);
        
        // Check for self-intersections before allowing the polygon creation
        if (instant.isSelfIntersecting(instant.geoLocMulArray[index])) {
          instant.geoLocMulArray[index].pop();
          alert('Polygon is invalid due to intersecting edges. Please redraw.');
          return;
        }else {
          instant.onSave(index);
        }
      }

      function error(err) {
        let detailsMsg = '';
        if(err?.message== 'User denied Geolocation'){
          detailsMsg = 'Please enable Geolocation access'
        } else{
          detailsMsg = 'Please capture again.'
        }
        instant.messageService.add({
          severity: 'error',
          summary: err.message,
          detail: detailsMsg
            ,
        });
      }

      navigator.geolocation.getCurrentPosition(success, error, options);
    }
  }

  isSelfIntersecting(coordsArray) {
    for (let i = 0; i < coordsArray.length - 1; i++) {
      for (let j = i + 2; j < coordsArray.length; j++) {
        // Prevent checking consecutive edges or the last edge with the first one
        if (i === 0 && j === coordsArray.length - 1) continue;
        if (this.doLinesIntersect(coordsArray[i], coordsArray[i + 1], coordsArray[j], coordsArray[(j + 1) % coordsArray.length])) {
          return true;
        }
      }
    }
    return false;
  }

  doLinesIntersect(p1, q1, p2, q2) {
    // Helper function to calculate orientation of the points
    function orientation(p, q, r) {
      let val = (q.lat - p.lat) * (r.lng - q.lng) - (q.lng - p.lng) * (r.lat - q.lat);
      if (val === 0) return 0; // collinear
      return (val > 0) ? 1 : 2; // clock or counterclockwise
    }

    // Check the four orientations needed for the general and special cases
    let o1 = orientation(p1, q1, p2);
    let o2 = orientation(p1, q1, q2);
    let o3 = orientation(p2, q2, p1);
    let o4 = orientation(p2, q2, q1);

    // General case
    if (o1 !== o2 && o3 !== o4) return true;

    // Special cases
    // p1, q1, p2 are collinear and p2 lies on segment p1q1
    if (o1 === 0 && this.onSegment(p1, p2, q1)) return true;

    // p1, q1, q2 are collinear and q2 lies on segment p1q1
    if (o2 === 0 && this.onSegment(p1, q2, q1)) return true;

    // p2, q2, p1 are collinear and p1 lies on segment p2q2
    if (o3 === 0 && this.onSegment(p2, p1, q2)) return true;

    // p2, q2, q1 are collinear and q1 lies on segment p2q2
    if (o4 === 0 && this.onSegment(p2, q1, q2)) return true;

    return false;
  }

  onSegment(p, q, r) {
    return q.lng <= Math.max(p.lng, r.lng) && q.lng >= Math.min(p.lng, r.lng) &&
      q.lat <= Math.max(p.lat, r.lat) && q.lat >= Math.min(p.lat, r.lat);
  }

  onSave(tableNo) {
    this.mapEnable = false;
    this.mapEnable = true;
    this.options.center = this.geoLocMulArray[tableNo][0];
    this.overlays = [];
    this.geoLocMulArray.forEach((arr, tableIndex) => {
      arr.forEach((row, index) => {
        this.addMarkers(row, index, tableIndex);
      });
    })
    
    this.addOverlay();
  }

  onNext() {}
  mobileSearch(value) {
    this.mobileFarmerPreEstimateSurveyData =
      this.farmerPreEstimateSurveyData.filter((data: any) => {
        if (
          data.appID.toLowerCase().includes(value.toLowerCase()) ||
          data.FarmerName.toLowerCase().includes(value.toLowerCase()) ||
          data.ProgrammeName.toLowerCase().includes(value.toLowerCase()) ||
          data.district.toLowerCase().includes(value.toLowerCase()) ||
          data.village.toLowerCase().includes(value.toLowerCase()) ||
          data.block.toLowerCase().includes(value.toLowerCase()) ||
          data.Status_Ar.toLowerCase().includes(value.toLowerCase())
        ) {
          return data;
        }
      });
  }
  addOverlay() {
    this.overlays.forEach((val, index) => {
      if(val?.fillColor){
        this.overlays.splice(index, 1);
      }
    })

    this.geoLocMulArray.forEach(arr => {
      this.overlays.push(
        new google.maps.Polygon({
          paths: arr,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          fillColor: '#1976D2',
          fillOpacity: 0.35,
        })
      );
    })
    

    let area = 0;
    this.geoLocMulArray.forEach(array => {
      if(array.length >= 3 ){
        let polygon = new google.maps.Polygon({paths: array});
        area += this.calculateLandArea(polygon.getPath());
      }
    });
    this.landArea = Number((0.000247105*area).toFixed(2));

    // if(this.geolocationsarray.length >=3){
    //   let polygon = new google.maps.Polygon({paths: this.geolocationsarray})
    //   let area = this.calculateLandArea(polygon.getPath());
    //   this.landArea = Number((0.000247105*area).toFixed(2));
    // }
    
    // this.onRefreshCurrentLocation();
  }

  calculateLandArea(polygon){
    return google?.maps?.geometry?.spherical.computeArea(polygon)
  }

  removeOverlay() {
    this.overlays.pop().setMap(null);
  }
  addMarkers(row: any, index, tableNo) {  
    this.overlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: `${row?.CornerID}`,
        // draggable: true,
        draggable: false,
        crossOnDrag: false
      })
    );
  }

  onDrag(event) {
    let indexVal = this.getTableAndCoordinateVal(event?.overlay?.title)


    let index = indexVal?.coordinateValue ? indexVal?.coordinateValue : 1;
    let tableNo = indexVal?.polygonIndex ? indexVal?.polygonIndex : 1;

    // index = event?.overlay?.title ? event?.overlay?.title.split(' ')[1] : -1;
    if (index >= 1) {
      this.geoLocMulArray[tableNo - 1][index - 1].lat = event?.overlay?.position?.lat();
      this.geoLocMulArray[tableNo - 1][index - 1].lng = event?.overlay?.position?.lng();

      this.removeOverlay();
      this.addOverlay();
    }
  }


  getTableAndCoordinateVal(val) {
    let polygonIndex = null; // Default to null if not present
    let coordinateValue = null; // Default to null if not present

    // Match both patterns
    const polygonMatch = val.match(/Polygon\s+(\d+)/);
    const coordinateMatch = val.match(/Coordinate\s+(\d+)/);

    // Extract polygon index if it exists
    if (polygonMatch) {
      polygonIndex = parseInt(polygonMatch[1], 10);
    }

    // Extract coordinate value if it exists
    if (coordinateMatch) {
      coordinateValue = parseInt(coordinateMatch[1], 10);
    }

    return { polygonIndex, coordinateValue };
  }

  showBasicDialog() {
    this.displayBasic = true;
  }

  // public triggerSnapshot(): void {
  //   this.trigger.next();
  // }

  public async triggerSnapshot(): Promise<void> {
    this.locationError = '';
    this.isLocationReady = false;
    try {
      const loc = await this.getLocation();
      this.locationCoords = loc;
      this.capturedLocation = `Lat: ${loc.lat.toFixed(6)}, Lng: ${loc.lng.toFixed(6)}`;
      const now = new Date();
      this.capturedDateTime = now.toLocaleString();
      this.isLocationReady = true;
      this.trigger.next();
    } catch (err) {
      this.locationError = typeof err === 'string' ? err : 'Unable to fetch GPS location. Please enable location services.';
      this.isLocationReady = false;
      this.messageService.add({ severity: 'error', summary: 'Location Error', detail: this.locationError });
    }
  }
  // Add watermark to image after capture
  public handleImage(webcamImage: WebcamImage): void {
    if (!this.isLocationReady || !this.locationCoords) {
      this.messageService.add({ severity: 'error', summary: 'Location Error', detail: 'Unable to fetch GPS location. Please enable location services.' });
      return;
    }
    let geoCoordinateError = false;
    this.geoLocMulArray.forEach((array, index) => {
      if(array.length < 4){
        this.coordinateError = `Please provide atleast 4 GPS Coordinates for polygon ${index+1}`;
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error Message',
        //   detail: `Please provide atleast 4 GPS Coordinates for polygon ${index+1}`,
        // });
        geoCoordinateError = true;
      }
    })
    if(geoCoordinateError){
       this.messageService.add({
          severity: 'warn',
          summary: 'Info Message',
          detail: `Please capture GPS Coordinates before taking the pictures.`,
        });
      return;
    } else {
      this.isInsideFencing = false;
      this.fencingError = '';
      let polygonCoords = [];
      let geoFencingCoords = [];

      geoFencingCoords = this.geoLocMulArray;
      
      try {
        const gpsCoordinate = geoFencingCoords;
        const polygonRaw = gpsCoordinate?.[0];
        if (polygonRaw) {
          polygonCoords = polygonRaw;
          // Expecting array of {lat, lng}
          if (Array.isArray(polygonCoords) && polygonCoords.length > 2) {
            this.isInsideFencing = this.isPointInPolygon(this.locationCoords, polygonCoords);
            if (!this.isInsideFencing) {
              this.fencingError = 'Captured Image/Photo seems outside from correct location on concerned farmer field. Kindly re-capture from right location.';
            }
          } else {
            this.fencingError = 'Geo-fencing polygon data is invalid.';
          }
        } else {
          this.fencingError = 'Geo-fencing polygon data not found.';
        }
      } catch (e) {
        this.fencingError = 'Error reading geo-fencing data.';
      }
    }
    
    const img = new Image();
    img.src = webcamImage.imageAsDataUrl;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const match = this.deviceName.match(/\(([^)]+)\)/);
      const result = match ? match[1] : null;
      // Watermark text
      const watermarkText1 = `Device Info: ${result ? result : this.deviceName}`;
      const watermarkText2 = `Location: ${this.capturedLocation}`;
      const watermarkText3 = `Date & Time: ${this.capturedDateTime}`;
      ctx.font = 'bold 15px Arial';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      // Word wrap utility
      function wrapText(context, text, x, y, maxWidth, lineHeight) {
        const words = text.split(' ');
        let line = '';
        let lines = [];
        for (let n = 0; n < words.length; n++) {
          const testLine = line + words[n] + ' ';
          const metrics = context.measureText(testLine);
          const testWidth = metrics.width;
          if (testWidth > maxWidth && n > 0) {
            lines.push(line.trim());
            line = words[n] + ' ';
          } else {
            line = testLine;
          }
        }
        lines.push(line.trim());
        for (let i = 0; i < lines.length; i++) {
          context.fillText(lines[i], x, y + i * lineHeight);
        }
        return lines.length;
      }
      // Watermark area config
      const margin = 5;
      const topPadding = 5;
      const betweenPadding = 3;
      const lineHeight = 15;
      const maxTextWidth = Math.min(canvas.width - margin * 2, 320); // max 320px or canvas width
      // Calculate wrapped lines for each watermark text
      let linesArr = [];
      linesArr.push(watermarkText1);
      linesArr.push(watermarkText2);
      linesArr.push(watermarkText3);
      // Calculate total lines for box height
      let totalLines = 0;
      let lineCounts = [];
      for (let i = 0; i < linesArr.length; i++) {
        const words = linesArr[i].split(' ');
        let line = '';
        let count = 0;
        for (let n = 0; n < words.length; n++) {
          const testLine = line + words[n] + ' ';
          const metrics = ctx.measureText(testLine);
          const testWidth = metrics.width;
          if (testWidth > maxTextWidth && n > 0) {
            count++;
            line = words[n] + ' ';
          } else {
            line = testLine;
          }
        }
        count++;
        lineCounts.push(count);
        totalLines += count;
      }
      const boxWidth = maxTextWidth + margin * 2;
      const boxHeight = topPadding + (lineHeight + betweenPadding) * totalLines + margin;
      const boxX = margin;
      const boxY = canvas.height - boxHeight - margin;
      // Draw black rectangle for watermark background
      ctx.save();
      ctx.globalAlpha = 0.1;
      ctx.fillStyle = '#fcfbfbff';
      // ctx.fillStyle = 'black';
      ctx.fillRect(boxX, boxY, boxWidth, boxHeight);
      ctx.restore();
      // Draw white text with wrapping
      ctx.fillStyle = '#fdfd05ff';
      // ctx.fillStyle = 'white';
      let y = boxY + topPadding;
      let lineIdx = 0;
      for (let i = 0; i < linesArr.length; i++) {
        const linesUsed = wrapText(ctx, linesArr[i], boxX + margin, y, maxTextWidth, lineHeight);
        y += linesUsed * lineHeight + betweenPadding;
        lineIdx += linesUsed;
      }
      const watermarkedDataUrl = canvas.toDataURL('image/jpeg');
      this.webcamImage = Object.assign({}, webcamImage, { imageAsDataUrl: watermarkedDataUrl });
      this.imageCaptured = true;
      this.pictureTaken.emit(this.webcamImage);
    };
  }
  // Utility: Point-in-polygon check (Ray-casting algorithm)
  private isPointInPolygon(point: {lat: number, lng: number}, polygon: Array<{lat: number, lng: number}>): boolean {
    let x = point.lng, y = point.lat;
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      let xi = polygon[i].lng, yi = polygon[i].lat;
      let xj = polygon[j].lng, yj = polygon[j].lat;
      let intersect = ((yi > y) !== (yj > y)) &&
        (x < (xj - xi) * (y - yi) / (yj - yi + 0.0000001) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }
  // Get GPS location before allowing capture
  async getLocation(): Promise<{lat: number, lng: number}> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject('Geolocation not supported');
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
          },
          (error) => {
            reject('Unable to fetch GPS location. Please enable location services.');
          }
        );
      }
    });
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
  }

  // public handleImage(webcamImage: WebcamImage): void {
  //   this.webcamImage = webcamImage;
  //   this.imageCaptured = true;
  //   this.pictureTaken.emit(webcamImage);
  // }

  public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public uploadPicture() {
    const arr = this.webcamImage.imageAsDataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    exifr
      .parse(this.webcamImage.imageAsDataUrl)
      .then((output) => {
      } );
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file: File = new File([u8arr], this.selctedFileType + '.jpeg', {
      type: mime,
    });
    let data = new FormData();
    data.append('file', file);
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let phNo = JSON.parse(payload)?.sub;
    // this.route.queryParams
    //   .subscribe(params => {
    // if (params.autoId) {
    this._personalDetalSer
      .uploadFile(data, phNo, this.selctedFileType.code)
      .subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          const fileName = `preEstimateSurvey_${new Date().getTime()}`;
          this.documentList.push({
            attachment: resp.data,
            attachmentRawUrl: this.webcamImage.imageAsDataUrl,
            document_type: this.selctedFileType.name,
            displayName: fileName,
            name: this.selctedFileType.name,
            // this.selctedFileType.code === 'farmer_photo'
            //   ? 'Farmer Photo'
            //   : this.selctedFileType.code === 'water_source'
            //     ? 'Water Source'
            //     : this.selctedFileType.code === 'land_photo'
            //       ? 'Land Photo'
            //       : this.selctedFileType.code === 'others'
            //         ? 'Others'
            //         : 'Component Photo',
            isUploaded: false,
          });

          // let documentListObject = {
          //   // 'appId': this.cryptoJsService.DecryptData(params.appId),
          //   'documentList': this.documentList
          // }
          // sessionStorage.setItem('documentList', JSON.stringify(documentListObject));
          this.selctedFileType = '';
          this.retake();
          this.displayCameraComponent = false;
        } else {
        }
        this.selctedFileType = '';
      });
    // });
  }
  retake() {
    this.imageCaptured = false;
  }
  onCaptureImage() {
    let geoCoordinateError = false;
    this.geoLocMulArray.forEach((array, index) => {
      if(array.length < 4){
        this.coordinateError = `Please provide atleast 4 GPS Coordinates for polygon ${index+1}`;
        this.messageService.add({
          severity: 'warn',
          summary: 'Info Message',
          detail: `Please provide atleast 4 GPS Coordinates for polygon ${index+1}`,
        });
        geoCoordinateError = true;
      }
    })
    if(geoCoordinateError){
      //  this.messageService.add({
      //     severity: 'warn',
      //     summary: 'Info Message',
      //     detail: `Please capture GPS Coordinates before taking the pictures.`,
      //   });
      return;
    }else{
      this.displayCameraComponent = true;
      this.locationError = '';
      this.isLocationReady = false;
      this.locationCoords = null;
    }
  }
  onCloseImageDialog() {
    this.displayCameraComponent = false;
    this.imageCaptured = false;
    this.imageCaptured = false;
    this.webcamImage = null;
    this.locationError = '';
    this.isLocationReady = false;
    this.locationCoords = null;
  }
  getImagesArray() {
    if (this.documentList.length == 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'ERROR_MESSAGE',
        detail: 'Images are Mandatory',
      });
      return;
    } else {
      this.uploadOptions.forEach((option) => {
        if (option.code != 'others') {
          let filtered = this.documentList.filter((doc) => {
            return doc.document_type == option.name;
          });
          if (filtered?.length == 0) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Atleast one ' + option.name + ' is Needed!',
            });
            return;
          }
        }
      });
    }
  }
  submitSurveyDetails() {
    let existImage = true;
    this.isSubmitted = true;
    if (this.submitEstimateForm.valid) {
      let geoCoordinateError = false;
      this.geoLocMulArray.forEach((array, index) => {
        if(array.length < 4){
          this.coordinateError = `Please provide atleast 4 GPS Coordinates for polygon ${index+1}`;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Please provide atleast 4 GPS Coordinates for polygon ${index+1}`,
          });
          geoCoordinateError = true;
        }
      })
      if (geoCoordinateError) {
        // this.coordinateError = 'PLEASE_PROVIDE_ATLEAST_4_GPS_COORDINATES';
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error Message',
        //   detail: 'Please provide atleast 4 GPS Coordinates',
        // });
        return;
      } else if((Math.abs(this.landArea - this.surveyArea) > 0.1*this.landArea)){
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: `Difference between Calculated Area (${this.landArea}) and Survey Area (${this.surveyArea}) is more. Please recapture the coordinates.`,
        });
        return;
      } else if (this.documentList.length == 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Images are Mandatory',
        });
        return;
      } else {
        this.uploadOptions.forEach((option) => {
          if (option.code != 'others') {
            let filtered = this.documentList.filter((doc) => {
              return doc.document_type == option.name;
            });
            if (filtered?.length == 0) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Atleast one ' + option.name + ' is Needed!',
              });
              existImage = false;
            }
          }
        });
        let attachemntArray = [];
        if (!existImage) {
          return;
        }
        for (let index = 0; index < this.documentList.length; index++) {
          const obj = {
            attachmentsDoc: this.documentList[index].attachment,
            documentType: this.documentList[index].document_type,
          };
          attachemntArray.push(obj);
        }
        // for (let index = 0; index < this.geolocationsarray.length; index++) {
          //   const gpsObj = {
            //     CornerID: index + 1,
            //     latitude: this.geolocationsarray[index].lat,
            //     longitude: this.geolocationsarray[index].lng,
            //   };
            //   geoCoordinates.push(gpsObj);
            // }
            
        let geoCoordinates: any []= [];
        this.geoLocMulArray.forEach((array) => {
          let val = array.map((val) => ({
            CornerID: val.CornerID,
            latitude: val.lat,
            longitude: val.lng
          }))
          geoCoordinates.push(val);
        })

        const dataObj = [
          {
            appID: this.programmeAppId,
            progID: this.ProgramID,
            FarmerName: this.programmeFarmerName,
            soilType: this.submitEstimateForm.value.soilType,
            cropTypeID: this.submitEstimateForm.value.cropType,
            cropID: this.submitEstimateForm.value.cropId,
            waterSourceId: this.submitEstimateForm.value.waterSource,
            waterPressure: this.submitEstimateForm.value.waterPressure,
            waterQuality: this.submitEstimateForm.value.waterQuality,
            PH: this.submitEstimateForm.value.ph,
            EC: this.submitEstimateForm.value.ec,
            waterQuantity: this.submitEstimateForm.value.waterReq,
            plantSpacing: parseFloat(this.submitEstimateForm.value.spacing.split("X")[1]),
            rowSpacing: parseFloat(this.submitEstimateForm.value.spacing.split("X")[0]),
            vendorCode: this.vendorCode,
            network_Id: this.ipAddress,
            terminal_Id: this.ipAddress,
            insertServeyAttachments: attachemntArray,
            insertSurveyGPSCoordiantes: geoCoordinates,
          },
        ];

        let reqBody = {
          "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(dataObj))
        }

        this.loader.start();
        this.flService
          .getPreEstimateSurvey(reqBody)
          .pipe(first())
          .subscribe({
            next: (resp) => {
              this.loader.close();
              this.loading = false;
              // this.activityRecordService.activityRecord(
              //   this.userId,
              //   'Pre-Estimation Survey Action (Current)',
              //   this.programmeAppId,
              //   new Date(),
              //   resp,
              //   dataObj[0]
              // );
              if(resp.startsWith("S:Successfully")){
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success Message',
                  detail: resp,
                });
                this.isSubmitted = true;
                this.onCloseDialog();
                this.loadData();
              }else{
                this.messageService.add({
                  severity: 'info',
                  summary: 'info Message',
                  detail: resp,
                });
                return;
              }
            },
            error: (err) => {
              this.loader.close();
              // this.activityRecordService.activityRecord(
              //   this.userId,
              //   'Pre-Estimation Survey Action (Err: Current)',
              //   this.programmeAppId,
              //   new Date(),
              //   err,
              //   dataObj[0]
              // );
              this.isSubmitted = true;
              // this.loader.close();
               this.loading = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: err,
              });
            },
          });
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please fill all the mandatory feilds',
      });
    }
  }
  removeImg(i) {
    this.documentList.splice(i, 1);
  }
  rowBackgroundColor(row) {
    if (row.Status_Ar == 'P') {
      if (row.Pending_CompletedDays <= -2) {
        return '#ff8080';
      } else if (row.Pending_CompletedDays == -1) {
        return '#ffc966';
      }
    } else if (row.Status_Ar == 'C' || row.Status_Ar == 'A') {
      if (row.Pending_CompletedDays >= -1) {
        return '#99e699';
      } else if (row.Pending_CompletedDays <= -2) {
        return '#ffb3b3';
      }
    } else return '#ffffff';
  }

  getRowPlantSpacing(progId){
    this.loader.start();
    let sub = this.vendorService
      .getProDataSpacing(progId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.length > 0) {
            this.rowPlantSpacingData = data; 
          }else{
            this.rowPlantSpacingData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found for row and plant spacing',
            });
          }
          
        },
        error: (err) => {
          this.rowPlantSpacingData = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

  addEstimation(data) {
    this.getRowPlantSpacing(data?.ProgramID);
    this.getCurrentLocation();
    this.addOverlay();
    this.geoLocMulArray = [];
    this.geoLocMulArray.push([])
    this.refreshLocation = setInterval(() =>
        this.onRefreshCurrentLocation(), 4000);

    // setTimeout(() => {
    //   if(!this.isGPSError){
    //     this.refreshLocation = setInterval(() =>
    //     this.onRefreshCurrentLocation(), 5000)
    //   }
    // }, 7000)

    

    this.displayPreEstDialog = true;
    this.geolocationsarray = [];
    this.programmeAppId = data.appID;
    this.programmeFarmerName = data.FarmerName;
    this.programName = data.ProgrammeName;
    this.ProgramID = data.ProgramID;
    this.vendorCode = data.Vendor_Code;
    this.isSubmitted = false;
    this.surveyArea = data.Total_Area;
    // this.applyConditionalValidation(data);
  }
  updateEstimation(data) {
    // this.getCurrentLocation();
    // this.addOverlay();
    // this.refreshLocation = setInterval(() =>
    //     this.onRefreshCurrentLocation(), 6000)
    this.getRowPlantSpacing(data?.ProgramID);
    this.geolocationsarray = [];
    this.geoLocMulArray = [];
    this.geoLocMulArray.push([])
    this.surveyArea = data.Total_Area
    
    this.isSubmitted = false;
    // this.applyConditionalValidation(data);
    this.displayPreEstDialog = true;
    this.programmeFarmerName = data.FarmerName;
    let reqBody = {
      AppId: data.appID,
      ProgramId: data.ProgramID,
    };
    // this.loader.start();
    this.loading = true;
    this.vendorService
      .GetEditPreEstimationSurvey(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (typeof data.WaterPressure == 'number') {
            data.WaterPressure = JSON.stringify(data.WaterPressure);
          }
          if (typeof data.WaterQuantity == 'number') {
            data.WaterQuantity = JSON.stringify(data.WaterQuantity);
          }
          // this.loader.close();
          this.loading = false;
          this.programmeAppId = data.AppID;
          this.programName = data.ProgramName;
          this.ProgramID = data.ProgId;
          this.vendorCode = data.VendorCode;
          this.f.soilType.setValue(data.SoilType);
          this.f.cropType.setValue(data.CropTypeID);
          this.f.cropId.setValue(data.CropId);
          this.f.waterSource.setValue(data.WaterSourceId);
          this.f.waterPressure.setValue(data.WaterPressure);
          this.f.waterQuality.setValue(data.WaterQuality);
          this.f.ph.setValue(data?.PH);
          this.f.ec.setValue(data?.EC);
          this.f.waterReq.setValue(data.WaterQuantity);
          // this.f.plantSpacing.setValue(data.PlantSpacing);
          // this.f.rowSpacing.setValue(data.RowSpacing);
          this.f.spacing.setValue(`${data.RowSpacing}X${data.PlantSpacing}`)
          for (let index = 0; index < data.listGPSCoordinates.length; index++) {
            let geoData = {
              CornerID: data.listGPSCoordinates[index].CornerID,
              lat: data.listGPSCoordinates[index].Latitude,
              lng: data.listGPSCoordinates[index].Longitude,
            };
            this.geolocationsarray.push(geoData);
          }
          if (this.geolocationsarray.length == 0) {
            this.mapEnable = false;
          } else {
            if (this.geolocationsarray && this.geolocationsarray.length > 0) {
              this.options.center = this.geolocationsarray[0];
            }
            this.mapEnable = true;
            this.geolocationsarray.forEach((row, index) => {
              this.addMarkers(row, index, 'tableNO');
            });
            this.addOverlay();
          }

          for (let index = 0; index < data.listImagePath.length; index++) {
            let imagesData = {
              attachment: data.listImagePath[index].ImagePath,
              attachmentRawUrl: data.listImagePath[index].ImagePath,
              document_type: data.listImagePath[index].DocumentType,
              displayName: data.listImagePath[index].DocumentType,
              name: data.listImagePath[index].DocumentType,
            };
            this.documentList.push(imagesData);
          }
        },
      });
  }

  applyConditionalValidation(data){
    // if(data?.ApplicantType == '7500' && data?.ProgrammeName == 'Drip Irrigation'){
    //   this.submitEstimateForm.controls['rowSpacing'].setValidators([Validators.min(0.3)]);
    //   this.submitEstimateForm.controls['plantSpacing'].setValidators([Validators.min(0.6)]);
    // }
    // else{
    //   this.submitEstimateForm.controls['rowSpacing'].clearValidators();
    //   this.submitEstimateForm.controls['plantSpacing'].clearValidators();
    //   this.submitEstimateForm.controls['rowSpacing'].setValidators([Validators.required]);
    //   this.submitEstimateForm.controls['plantSpacing'].setValidators([Validators.required]);
    // }
    // this.submitEstimateForm.controls['rowSpacing'].updateValueAndValidity();
    // this.submitEstimateForm.controls['plantSpacing'].updateValueAndValidity();
  }

  selectViewApplication(application, statusCode) {
    if (application.appID) {
      let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      const link = this.router.serializeUrl(
        this.router.createUrlTree([
          this.router.url.split('/')[1],
          'print',
        ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.appID.toString()) } }));
      window.open(link, '_blank');
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Invalid App ID',
      });
    }
  }
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP ID': d.appID,
          'date of Submit':d.registerationDate_filter,
          'date of Resubmit':d.registerationReassignDate_filter,
          'Applicant Type': d.ApplicantType,
          'App type': d.FarmerName,
          "Village": d.village,
          'block': d.block,
          'District': d.district,
          'Age Of Application': d.AgeOfApplication,
          'Program Name': d.ProgrammeName,
          'Land Detail': d.LandDetail,
          'Total Area': d.Total_Area,
          'current status': d.Status_Ar,
          'Remarks': d.DeptRemarks,
          'Act on PrevAction': d.ActOnPrevAction,
          
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'appID', header: 'appID' },
      { field: 'registerationDate_filter', header: 'date of Submit' },
      { field: 'registerationReassignDate_filter', header: 'date of Resubmit' },
      { field: 'ApplicantType', header: 'Applicant type' },
      { field: 'FarmerName', header: 'Farmer Name' },
      { field: 'village', header: 'village' },
      { field: 'block', header: 'block' },
      { field: 'district', header: 'district' },
      { field: 'AgeOfApplication', header: 'Age Of Application' },
      { field: 'ProgrammeName', header: 'Program Name' },
      { field: 'LandDetail', header: 'Land Detail' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'Status_Ar', header: 'current status' },
      { field: 'DeptRemarks', header: 'Remarks' },
      { field: 'ActOnPrevAction', header: 'Act on PrevAction' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});

        doc.save(`${filename}.pdf`);
      });
    });
  }
  refreshTable() {
    // this.tankDataTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
    this.loadData();
  }
}

